import { render, staticRenderFns } from "./DayNews.vue?vue&type=template&id=6d4c3670&"
import script from "./DayNews.vue?vue&type=script&lang=js&"
export * from "./DayNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports